module.exports = __webpack_public_path__ + "img/header2.7c234191.png";